import useCopayStore from './useCopay.store';
import useHealthPlansStore from './useHealthPlans.store';
import useRenewalSetupStore from './useRenewalSetup.store';

export const resetAllStores = () => {
  useRenewalSetupStore.getState().handleReset();
  useCopayStore.setState({ ...useCopayStore.getInitialState() });
  useHealthPlansStore.getState().handleReset();
};
